module.exports = __webpack_public_path__ + "assets/img/Essential_cover.21abfc48-ps.jpg";